export const setItensCarrinho = itens => localStorage.setItem('itensCarrinho', JSON.stringify(itens))
export const setCupomDataDoCarrinho = cupom => localStorage.setItem('cupomDataDoCarrinho', cupom)
export const deleteItensCarrinho = () => localStorage.removeItem('itensCarrinho')
export const deleteCupomCarrinho = () => localStorage.removeItem('cupomDataDoCarrinho')
export const getItensCarrinho = () => {
  const itensCarrinho = localStorage.getItem('itensCarrinho')
  if (itensCarrinho !== undefined) {
    return itensCarrinho ? JSON.parse(itensCarrinho) : []
  }

  return []
}
export const getCupomDataDoCarrinho = () => localStorage.getItem('cupomDataDoCarrinho')
